import { Vault } from '@/features/vaults/types';
import { mezoUSD, mUSDC, mUSDT } from '@/features/vaults/constants/vaults/mezo/tokens/mezoUSDs';
import {
  ethereumMezoStableVaultAddress,
  ethereumMezoStableVaultId,
} from '@/features/vaults/constants/vaults/mezo/mezo-stable-vault-on-ethereum';

export const mezoStableVaultId = 'mezo-stable-vault';
export const mezoStableVaultAddress = '0x07AFFA6754458f88db83A72859948d9b794E131b';

export const mezoStableVault: Vault = {
  migrations: [
    {
      network: 'ethereum',
      address: ethereumMezoStableVaultAddress,
      id: ethereumMezoStableVaultId,
    },
  ],
  id: mezoStableVaultId,
  type: 'core-vault',
  name: 'Mezo Stable Vault',
  description:
    "Mezo's flagship stablecoin yield vault. Deposit MUSD, USDC, or USDT to access delta-neutral yield strategies spanning basis trades, funding rate arbitrage, stable pair liquidity on DEXes across EVM chains, and borrow/lend opportunities.\n" +
    '<br/><br/>' +
    'Curator: Perseus Digital — Quantitative trading firm specializing in delta-neutral strategies across CeFi and DeFi. Expertise in basis trading, funding rate arbitrage, and other market-neutral liquidity strategies.',
  category: 'core-vault',
  address: mezoStableVaultAddress,
  curators: ['mezo', 'perseus'],
  operator: [],
  points: [{ entity: 'mellow', startTimestamp: 1760967575 }],
  network: 'mezo',
  networks: [
    {
      network: 'mezo',
      vaultAddress: mezoStableVaultAddress,
    },
  ],
  depositTokens: [
    {
      address: mUSDC,
      decimals: 6,
      symbol: 'mUSDC',
    },
    {
      address: mezoUSD,
      decimals: 18,
      symbol: 'Mezo USD',
    },
    {
      address: mUSDT,
      decimals: 6,
      symbol: 'mUSDT',
    },
  ],
  baseToken: mUSDC,
  lpTokenSymbol: 'msvUSD',
  lpTokenDecimals: 18,
  oracleUpdateInterval: BigInt(86400),
  redeemHandlingInterval: BigInt(3600),
  allocations: {
    showAllocationsTab: false,
  },
  prioritizedQueues: [],
  isInstantDeposit: true,
};
